import {
  FileText, Scissors, Combine, Minimize2, RotateCw, FileImage, FileType,
  FileCode, Book, FileSpreadsheet, Presentation, Image as ImageIcon,
  Crop, FlipHorizontal, Sparkles, Wand2, Zap, Sun, Palette, Type,
  Lock, Unlock, Shield, Eye, EyeOff, KeyRound, Trash2, ScanLine,
  Signature, Highlighter, MessageSquare, Layers, GitCompareArrows,
  Ban, FilePlus, Files, Hash, Table2, Braces, FileJson, FileCheck2,
  Bot, Languages, SpellCheck, MessageCircle, Database, Info, Focus,
  ImagePlus, Grid2X2, Copy, ListChecks, PieChart, BarChart3, FileLock2,
  UserSquare, Undo2, TrendingUp, Fingerprint, CloudUpload, Ratio
} from "lucide-react";

const MAP = {
  // PDF
  "merge-pdf": Combine, "split-pdf": Scissors, "compress-pdf": Minimize2,
  "pdf-to-word": FileType, "pdf-to-excel": FileSpreadsheet, "pdf-to-powerpoint": Presentation,
  "pdf-to-jpg": FileImage, "pdf-to-text": FileText, "pdf-to-html": FileCode,
  "pdf-to-epub": Book, "word-to-pdf": FileType, "excel-to-pdf": FileSpreadsheet,
  "ppt-to-pdf": Presentation, "jpg-to-pdf": FileImage, "png-to-pdf": FileImage,
  "html-to-pdf": FileCode, "scan-to-pdf": ScanLine, "ocr-pdf": ScanLine,
  "edit-pdf": Type, "add-watermark": Highlighter, "remove-watermark": Ban,
  "add-page-numbers": Hash, "add-header-footer": FilePlus, "rotate-pdf": RotateCw,
  "delete-pages": Trash2, "rearrange-pages": Layers, "crop-pdf": Crop,
  "resize-pdf": Ratio, "unlock-pdf": Unlock, "protect-pdf": Lock,
  "sign-pdf": Signature, "request-esign": Signature, "fill-forms": FileCheck2,
  "create-form": FilePlus, "highlight-text": Highlighter, "add-comments": MessageSquare,
  "compare-pdfs": GitCompareArrows, "redact-pdf": EyeOff, "flatten-pdf": Layers,
  "repair-pdf": Undo2,
  // Image
  "jpg-to-png": ImageIcon, "png-to-jpg": ImageIcon, "webp-converter": ImageIcon,
  "heic-converter": ImageIcon, "svg-converter": ImageIcon, "bmp-converter": ImageIcon,
  "tiff-converter": ImageIcon, "gif-converter": ImageIcon, "avif-converter": ImageIcon,
  "ico-converter": ImageIcon, "resize-image": Ratio, "compress-image": Minimize2,
  "crop-image": Crop, "rotate-image": RotateCw, "flip-image": FlipHorizontal,
  "remove-bg": Wand2, "ai-enhance": Sparkles, "ai-upscale": TrendingUp,
  "ai-denoise": Sparkles, "sharpen-image": Focus, "brightness-contrast": Sun,
  "blur-image": Eye, "watermark-image": Highlighter, "face-blur": UserSquare,
  "object-removal": Wand2, "image-to-text": ScanLine, "image-metadata": Info,
  "remove-exif": EyeOff, "image-collage": Grid2X2,
  // Word
  "docx-to-txt": FileText, "docx-to-html": FileCode, "html-to-docx": FileType,
  "merge-docx": Combine, "split-docx": Scissors, "compress-docx": Minimize2,
  "protect-docx": Lock, "remove-comments": MessageSquare, "track-changes-cleaner": FileCheck2,
  // Excel
  "csv-to-excel": FileSpreadsheet, "excel-to-csv": FileSpreadsheet, "excel-to-json": Braces,
  "json-to-excel": FileJson, "merge-excel": Combine, "split-excel": Scissors,
  "xml-to-excel": FileCode, "excel-to-xml": FileCode, "protect-excel": Lock,
  "remove-duplicates": Copy, "data-cleaning": ListChecks, "pivot-generator": Table2,
  "excel-charts": BarChart3,
  // PPT
  "ppt-compress": Minimize2, "merge-ppt": Combine, "split-ppt": Scissors,
  "ppt-to-images": ImagePlus, "images-to-ppt": Presentation, "pdf-to-ppt": Presentation,
  "ppt-protect": Lock,
  // AI
  "ai-summarize": Sparkles, "ai-translate": Languages, "ai-grammar": SpellCheck,
  "ai-chat": MessageCircle, "ai-extract": Database, "ai-qa": Bot,
  "ai-resume": FileText, "ai-invoice": FileSpreadsheet, "ai-contract-analyzer": FileCheck2,
  "ai-table-recognition": Table2, "ai-form-autofill": FileCheck2,
  "ai-handwriting": Signature, "ai-image-gen": ImageIcon,
  // OCR
  "ocr-image": ScanLine, "ocr-scanned-pdf": ScanLine, "ocr-multi-lang": Languages,
  "ocr-handwriting": Signature, "ocr-tables": Table2,
  // Security
  "file-encrypt": FileLock2, "file-decrypt": Unlock, "password-generator": KeyRound,
  "secure-share": Shield, "auto-delete": Trash2, "virus-scan": Shield,
  "digital-sign-verify": Fingerprint,
};

const CATEGORY_FALLBACK = {
  pdf: FileText, image: ImageIcon, word: FileType, excel: FileSpreadsheet,
  powerpoint: Presentation, ai: Sparkles, ocr: ScanLine, security: Shield,
};

export function getToolIcon(id, category) {
  return MAP[id] || CATEGORY_FALLBACK[category] || FileText;
}

export { CloudUpload, Zap, Palette };
